import { tracked } from '@glimmer/tracking';
import { action } from '@ember/object';
import Controller from '@ember/controller';

export default class IndexController extends Controller {
  @action
  setSearchQuery(value) {
    this.searchQuery = value;
  }

  queryParams = ['searchQuery'];
  @tracked
  searchQuery = '';

  @action
  refresh() {
    this.model.update();
  }
}
